// Hooks / Node modules / Styles

// Reducers / Actions

// Utils / Functions

// Components

// Sub-Components
import ExperienceCard from "./ExperienceCard";

// Data / Images / Icons
import { EXPERIENCES } from "src/data/pages/experinces";

function ExceprinceCardGroup() {
  return (
    <div className="space-y-6 select-none">
      {EXPERIENCES.map((exp) => (
        <ExperienceCard key={exp.id} experience={exp} />
      ))}
    </div>
  );
}

export default ExceprinceCardGroup;
